import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';

import './styles.less';

const ProposalCard = ({ logo, name, subtitle, datacy, id, onClick }) => (
  <Card onClick={() => onClick?.()} id={id} className="proposal-card" data-cy={datacy}>
    <div className="proposal-card-inner">
      <div className="proposal-card-main">
        {logo?.url ? (
          <img src={logo.url} alt={name} />
        ) : (
          <span className="proposal-number">{name}</span>
        )}
      </div>
      {subtitle && <span className="proposal-subtitle">{subtitle}</span>}
    </div>
  </Card>
);

ProposalCard.propTypes = {
  logo: PropTypes.shape(),
  name: PropTypes.string,
  subtitle: PropTypes.string,
  datacy: PropTypes.string,
  id: PropTypes.string,
  status: PropTypes.shape({
    name: PropTypes.string,
    colors: PropTypes.arrayOf(PropTypes.string),
    parent: PropTypes.shape({
      name: PropTypes.string,
      colors: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  onClick: PropTypes.func,
};

export default memo(ProposalCard);
